/**
 * Shared parser for checklist item deep links across web, Member, and Helper apps.
 */

export function isPeriodKey(key?: string | null): key is string {
  if (!key) return false
  return /^\d{4}-\d{2}-\d{2}$/.test(key) || /^\d{4}-W\d{2}$/.test(key)
}

export interface ChecklistDeepLinkResult {
  itemId: string
  periodKey?: string
  workspaceId?: string
}

export function parseChecklistDeepLink(location?: string | {
  search?: string
  hash?: string
} | null): ChecklistDeepLinkResult | null {
  if (!location) return null
  let searchStr = ''
  let hashStr = ''

  if (typeof location === 'string') {
    const qIndex = location.indexOf('?')
    const hIndex = location.indexOf('#')
    if (qIndex >= 0) {
      searchStr = hIndex > qIndex ? location.slice(qIndex + 1, hIndex) : location.slice(qIndex + 1)
    }
    if (hIndex >= 0) {
      hashStr = location.slice(hIndex)
    }
  } else {
    searchStr = typeof location.search === 'string' ? (location.search.startsWith('?') ? location.search.slice(1) : location.search) : ''
    hashStr = typeof location.hash === 'string' ? location.hash : ''
  }

  const searchParams = new URLSearchParams(searchStr)

  const itemParam = searchParams.get('item')
  if (itemParam && itemParam.trim()) {
    const itemId = itemParam.trim()
    const workspaceId = searchParams.get('ws')?.trim() || searchParams.get('workspaceId')?.trim() || undefined

    const dayParam = searchParams.get('day')?.trim()
    const weekParam = searchParams.get('week')?.trim()

    let periodKey: string | undefined
    if (dayParam && /^\d{4}-\d{2}-\d{2}$/.test(dayParam)) {
      periodKey = dayParam
    } else if (weekParam && /^\d{4}-W\d{2}$/.test(weekParam)) {
      periodKey = weekParam
    }

    return {
      itemId,
      ...(periodKey ? { periodKey } : {}),
      ...(workspaceId ? { workspaceId } : {}),
    }
  }

  // Legacy hash format: #checklist-<id>
  const hash = hashStr
  const hashMatch = hash.match(/^#checklist-(.+)$/)
  if (hashMatch && hashMatch[1]?.trim()) {
    return {
      itemId: hashMatch[1].trim(),
    }
  }

  return null
}
